<template>
  <div>
    <div class="d-flex" v-for="(l, index) in list" :key="index">
      <div class="a-flex">
        <ph-circle
          :size="25"
          color="#494647"
          class="drag-handle"
          :weight="numberListItem == index ? 'fill' : 'regular'"
          style="cursor: pointer"
          @click="selectValue(index, l.value)"
        />

        <select v-model="l.prefix" style="margin-left: 1rem">
          <option
            v-for="option in options"
            v-bind:value="option.value"
            :key="option.value"
          >
            {{ option.text }}
          </option>
        </select>
      </div>

      <input class="disabled-field" type="text" disabled v-model="l.value" />

      <div class="list-buttons">
        <button
          class="list-button"
          :disabled="l.indent <= 0"
          @click="l.indent--"
          v-if="index > 0"
        >
          <ph-caret-double-left />
        </button>
        <p v-if="index > 0" style="margin: 0 0.2rem">
          {{ l.indent }}
        </p>
        <button v-if="index > 0" class="list-button" @click="l.indent++">
          <ph-caret-double-right />
        </button>
        <div
          v-if="index > 0"
          class="list-button trash"
          @click="$emit('removeListItem', index)"
        >
          <ph-trash />
        </div>
        <div class="list-button green" @click="$emit('addListItem', index + 1)">
          <ph-plus />
        </div>
      </div>
    </div>

    <vue-easymde
      :configs="easyMdConfig"
      v-if="elementValue != null"
      ref="markdownEditor"
      :value="elementValue"
      @update:modelValue="handleInput"
      @blur="deselectValue"
    />
  </div>
</template>

<script>
import {
  PhPlus,
  PhTrash,
  PhCircle,
  PhCaretDoubleRight,
  PhCaretDoubleLeft,
} from "phosphor-vue";
import { mapActions } from "vuex";
import { trimString } from "../utils/helpers";

export default {
  name: "ListEditor",
  components: {
    PhPlus,
    PhTrash,
    PhCircle,
    PhCaretDoubleRight,
    PhCaretDoubleLeft,
  },
  data() {
    return {
      numberListItem: null,
      elementValue: null,
      options: [
        { text: "Ordered", value: "1." },
        { text: "Unordered", value: "-" },
        { text: "None", value: "" },
      ],
    };
  },
  provide: {
    size: 22,
    weight: "regular",
    mirrored: false,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {
    selectValue(index, value) {
      this.numberListItem = index;
      this.elementValue = "";
      this.elementValue = value;
    },
    deselectValue() {
      this.numberListItem = null;
      this.elementValue = null;
    },
    handleInput(e) {
      this.setValueOfListItem({
        index: this.numberListItem,
        value: trimString(e),
      });
    },
    ...mapActions(["setValueOfListItem"]),
  },
  computed: {
    easyMdConfig() {
      return {
        status: false, // disable the status bar at the bottom
        spellChecker: false, // disable spell check
        sideBySideFullscreen: false,
        syncSideBySidePreviewScroll: false,
        nativeSpellcheck: false,
        promptURLs: true,
        maxHeight: "100px",
        toolbar: this.toolbarOptions,
      };
    },
    toolbarOptions() {
      return ["bold", "italic", "strikethrough", "link"];
    },
  },
};
</script>

<style lang="scss">
.CodeMirror,
.CodeMirror-scroll {
  // max-height: 200px;
  margin-bottom: 1rem;
}

.editor-preview {
  display: none !important;
}

.text-editor {
  background-color: transparent;
  transition: max-height 0.2s ease-out;
  overflow: hidden;
  max-height: 0;
  min-height: 0;
  min-width: 0;
  margin-top: 1rem;
}
.d-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.a-flex {
  display: flex;
  align-items: center;
}
.disabled-field {
  background-color: #494647;
  color: white;
  // border-radius: 2px;
  border: 1px solid rgba(3, 3, 3, 0.171);
  padding: 1rem;
  font-family: "Rubik";
  margin-bottom: 0 !important;
  width: 50% !important;
  transition: all 0.2s ease;
  &:focus {
    background-color: #494647;
    color: white;
    // border-radius: 2px;
    border: 1px solid rgba(255, 255, 255, 0.692);
    padding: 1rem;
    outline: none;
  }
}

.list-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 11rem;
  // & > :first-child {
  //   margin: 0.3rem 0;
  // }
}

.list-button {
  width: 20px;
  border: 0;
  cursor: pointer;
  height: 1.075rem;
  border-radius: 30px;
  font-size: 1rem;
  letter-spacing: 0.2px;
  min-height: 1.888em;
  min-width: 1.888em;
  margin-bottom: 0.626em;
  padding: 0.3em;
  margin: 0.3rem;
  color: #494647;
  // background: #343233;
  fill: #494647;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  &:disabled {
    // background-color: rgb(36, 36, 36) !important;
    opacity: 0.3;
  }
  &:hover {
    background: lighten(#343233, 10%);
    color: rgb(255, 255, 255);
  }

  &.green:hover {
    background: #7fcb41bd !important;
  }

  &.trash:hover {
    background: #cb4a41bd !important;
  }
}
</style>
